<template>
  <div class="warp">
    <login-form class="inner"/>
    <div class="sep" />
    <bbs-form class="inner"/>
  </div>
</template>
<script>
import LoginForm from '@/components/LOGIN/index.vue'
import BbsForm from '@/components/BBS/index.vue'
import * as AuthApi from '@/api/auth';

export default {
  name:'Login',
  components: {
    LoginForm,
    BbsForm
  },
  data: () => ({
  }),
  computed: {},
  beforeRouteEnter(to, from, next){
    AuthApi.ssoLoginUrlKorus()
    .then((e) => {
      if(e.status === 200){
           const url = e.data;
           next({ name: 'empty' })
           return Promise.resolve(url);
      }
      return Promise.reject('-1');
    })
    .then((e) => {
       location.href = e;
    })
    .catch(() => {
      next();
    })
  },
};
</script>

<style lang="scss" scoped>
  $breakpoint: 900px;
  .warp {
    display: flex;

    @media (max-width: $breakpoint) {
      flex-direction: column;
    }
    .sep {
      border: 1px solid #ddd;
      margin: 0px 40px;
      @media (max-width: $breakpoint) {
        margin: 20px 0px;
      }
    }
    .inner{
      max-width: 400px;
      @media (min-width: $breakpoint) {
        min-width: 400px;
      }
    }
  }
</style>
